import { cacheDom } from '../utils/QuerySelectors.js'
import { makeRequest } from '../utils/Storefront.js'
import { getStoreQuery, formatStoreData } from '../utils/Store.js'
import Fuse from 'fuse.js'

const dom = {}
const qs = {
  section: 'data-section-type="eyewear-stores-list"',
  reverseSection: 'data-section-type="stores-list"',
  swiper: 'data-eyewear-featured-stores',
  input: 'data-store-zipcode',
  listWrap: 'data-stores-list-wrap',
  hero: 'data-hero-image',
  regionSelectWrap: 'data-region-select-wrap',
  regionSelector: 'data-region-selector',
  list: 'data-eyewear-stores-list',
}

const qsAll = {
  current: 'data-store-current',
  viewAll: 'data-all-stores',
}
const fuseOptions = {
  includeScore: true,
  keys: [
    {
      name: 'addressForSearch',
      weight: 1,
    },
    {
      name: 'address',
      weight: 1,
    },
    {
      name: 'zipcode',
      weight: 2,
    },
    {
      name: 'city',
      weight: 3,
    },
    {
      name: 'country',
      weight: 4,
    },
    {
      name: 'region',
      weight: 5,
    },
  ],
  // useExtendedSearch: true,
}
// Country name values should be matched in the metaobject country values.
const state = {
  fuse: null,
  countries: {
    en: {
      US: 'United States',
      CA: 'Canada',
      CN: 'China, Mainland',
      IT: 'Italy',
      JP: 'Japan',
      KR: 'South Korea',
      HK: 'Hong Kong SAR',
      PT: 'Portugal',
      TW: 'Taiwan Region',
      UK: 'United Kingdom',
      FR: 'France',
      RU: 'Russian Federation',
      AU: 'Australia',
      MO: 'Macau SAR',
      CH: 'Switzerland',
      DE: 'Germany',
      TH: 'Thailand',
      AE: 'U.A.E.',
      UA: 'Ukraine',
      AT: 'Austria',
      BE: 'Belgium',
      DK: 'Denmark',
      GR: 'Greece',
      KW: 'Kuwait',
      LB: 'Lebanon',
      MG: 'Madagascar',
      MY: 'Malaysia',
      MX: 'Mexico',
      NL: 'Netherlands',
      PH: 'Philippines',
      SK: 'Slovakia',
      ES: 'Spain',
      SE: 'Sweden',
      TK: 'Tokelau',
      SG: 'Singapore',
    },
    ko: {
      US: '미국',
      CA: '캐나다',
      CN: '중국 본토',
      IT: '이탈리아',
      JP: '일본',
      KR: '대한민국',
      HK: '홍콩 특별행정구',
      PT: '포르투갈',
      TW: '대만 지역',
      UK: '영국',
      FR: '프랑스',
      RU: '러시아 연방',
      AU: '호주',
      MO: '마카오 특별행정구',
      CH: '스위스',
      DE: '독일',
      TH: '태국',
      AE: '아랍에미리트',
      UA: '우크라이나',
      AT: '오스트리아',
      BE: '벨기에',
      DK: '덴마크',
      GR: '그리스',
      KW: '쿠웨이트',
      LB: '레바논',
      MG: '마다가스카르',
      MY: '말레이시아',
      MX: '멕시코',
      NL: '네덜란드',
      PH: '필리핀',
      SK: '슬로바키아',
      ES: '스페인',
      SE: '스웨덴',
      TK: '토켈라우',
      SG: '싱가포르',
    },
    ja: {
      US: 'アメリカ合衆国',
      CA: 'カナダ',
      CN: '中国本土',
      IT: 'イタリア',
      JP: '日本',
      KR: '韓国',
      HK: '香港特別行政区',
      PT: 'ポルトガル',
      TW: '台湾地域',
      UK: 'イギリス',
      FR: 'フランス',
      RU: 'ロシア連邦',
      AU: 'オーストラリア',
      MO: 'マカオ特別行政区',
      CH: 'スイス',
      DE: 'ドイツ',
      TH: 'タイ',
      AE: 'アラブ首長国連邦',
      UA: 'ウクライナ',
      AT: 'オーストリア',
      BE: 'ベルギー',
      DK: 'デンマーク',
      GR: 'ギリシャ',
      KW: 'クウェート',
      LB: 'レバノン',
      MG: 'マダガスカル',
      MY: 'マレーシア',
      MX: 'メキシコ',
      NL: 'オランダ',
      PH: 'フィリピン',
      SK: 'スロバキア',
      ES: 'スペイン',
      SE: 'スウェーデン',
      TK: 'トケラウ',
      SG: 'シンガポール',
    },
  },
}

const fetchStoresRecursively = (query) => {
  makeRequest((results) => {
    const stores = results.data?.metaobjects?.edges?.map((edge) => formatStoreData('eyewear_store', edge)) || []
    window.eyewearStoresList = window.eyewearStoresList.concat(stores)

    const pageInfo = results.data?.metaobjects?.pageInfo
    if (pageInfo?.hasNextPage) {
      const nextQuery = getStoreQuery('eyewear_store', 250, pageInfo.endCursor)
      fetchStoresRecursively(nextQuery)
    }
  }, query)
}

const getStores = () => {
  const query = getStoreQuery('eyewear_store', 250)
  window.eyewearStoresList = []
  fetchStoresRecursively(query)
}

export const setupEyewearStoresList = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    const swiperElement = dom.section.querySelector(`[${qs.swiper}]`)

    new Swiper(swiperElement, {
      autoplay: {
        delay: 5000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    })

    getStores()
    // dom.input.addEventListener('input', (e) => {
    //   state.fuse = new Fuse(window.eyewearStoresList, fuseOptions)
    //   const results = state.fuse.search(e.target.value.trim().toLowerCase())
    //   dom.regionSelector.value = ''
    //   window.setEyewearStoreResults(results, 0.1)
    // })
    dom.regionSelector.addEventListener('change', () => {
      dom.input.value = ''
      state.fuse = new Fuse(window.eyewearStoresList, {
        includeScore: true,
        keys: [{ name: 'region' }],
        useExtendedSearch: true,
      })
      let results = state.fuse.search(`=${dom.regionSelector.value?.replace(' ', '|')}`)
      window.setEyewearStoreResults(
        results,
        0.2,
        window.regionImages.filter((region) => region.name == dom.regionSelector.value)[0]?.image,
      )
      setTimeout(() => {
        window.scrollTo({
          top: dom.listWrap.offsetTop - 120,
          left: 0,
          behavior: 'smooth',
        })
      }, 100)
      // dom.reverseSection.classList.add('hidden')
    })
    dom.viewAll.forEach((viewAll) => {
      viewAll.addEventListener('click', () => {
        dom.input.value = ''
        dom.regionSelector.value = ''
        window.setEyewearStoreResults([])
        setTimeout(() => {
          window.scrollTo({
            top: dom.listWrap.offsetTop - 120,
            left: 0,
            behavior: 'smooth',
          })
        }, 100)
      })
    })
    dom.current.forEach((current) => {
      current.addEventListener('click', () => {
        fetch('https://ipinfo.io/json')
          .then((res) => res.json())
          .then((res) => {
            if (res.city) {
              const locale = window.Shopify?.locale || 'en'
              const countryMap = state.countries[locale] || state.countries['en']
              const countryName = countryMap[res.country]
              const countryStores = countryName
                ? window.eyewearStoresList.filter((store) => store.country?.toLowerCase() === countryName.toLowerCase())
                : window.eyewearStoresList

              state.fuse = new Fuse(countryStores, {
                includeScore: true,
                keys: [{ name: 'city' }],
              })
              let results = state.fuse.search(res.city.toLowerCase()).filter((result) => result.score <= 0.05)

              if (results.length == 0 && res.postal) {
                state.fuse = new Fuse(countryStores, {
                  includeScore: true,
                  keys: [{ name: 'zipcode' }],
                })
                results = state.fuse.search(res.postal.toLowerCase()).filter((result) => result.score <= 0.05)
              }
              if (results.length == 0) {
                results = countryStores.map((item) => ({ item, score: 0 }))
              }
              window.setEyewearStoreResults(results, 0.1)
            }
          })
      })
    })
  }
}
